import type { EmailDesign } from "../email-design/server/supabase-email-design-service";
import {
  type GenericToolbarDropdownElement,
  type GenericToolbarElement,
} from "../message/editor/plugins/generic-toolbar/types";

export function makeEmailToolbarTopLevelElements(template?: {
  settings?: {
    emailDesigns: EmailDesign[];
    selectedEmailDesign?: EmailDesign;
    setEmailDesign: (ed?: EmailDesign) => void;
    isDirty?: boolean;
  };
}): GenericToolbarElement[] {
  const contentDropdownChildren: GenericToolbarDropdownElement[] = [
    { type: "addImagesAndFiles" },
    { type: "imageButton" },
    { type: "addButton", channel: "work_email" },
    { type: "dynamicContent" } as const,
    { type: "addDivider", channel: "work_email" },
    { type: "columnsButton" },
    { type: "tableButton" },
    { type: "surveyAnswersButton" },
  ];

  return [
    ...(template?.settings
      ? [{ type: "emailTemplateSelector", settings: template.settings } as const]
      : []),
    { type: "blockFormat" },
    { type: "bold" },
    { type: "italic" },
    { type: "underline" },
    { type: "mergeTagPicker" },
    { type: "linkButton" },
    { type: "emojiPicker" },
    { type: "fontColourSelect" },
    { type: "fontBackgroundColourSelect" },
    ...(template ? [{ type: "paperColourSelect" } as const] : []),
    {
      type: "toolbarDropDown",
      children: contentDropdownChildren,
    },
    { type: "alignmentButtons" },
    { type: "pollButton" },
    { type: "surveyButton", channel: "work_email" } as const,
  ];
}
